var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegisterBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2924 25.0562C35.378 24.4 35.4209 23.7219 35.4209 23C35.4209 22.3 35.378 21.6 35.2709 20.9437L39.6188 17.4875C40.0043 17.1812 40.1114 16.5906 39.8758 16.1531L35.7635 8.89062C35.5065 8.40937 34.9711 8.25625 34.4999 8.40937L29.381 10.5094C28.3101 9.67812 27.175 8.97812 25.9113 8.45312L25.1403 2.89687C25.0546 2.37187 24.6263 2 24.1122 2H15.8878C15.3737 2 14.9668 2.37187 14.8811 2.89687L14.1101 8.45312C12.8464 8.97812 11.6899 9.7 10.6404 10.5094L5.52152 8.40937C5.05033 8.23437 4.51489 8.40937 4.25787 8.89062L0.16706 16.1531C-0.0899543 16.6125 -0.00428309 17.1812 0.424074 17.4875L4.7719 20.9437C4.66481 21.6 4.57914 22.3219 4.57914 23C4.57914 23.6781 4.62197 24.4 4.72906 25.0562L0.381238 28.5125C-0.00428304 28.8187 -0.111372 29.4094 0.124224 29.8469L4.23645 37.1094C4.49347 37.5906 5.02891 37.7437 5.50011 37.5906L10.619 35.4906C11.6899 36.3219 12.825 37.0219 14.0887 37.5469L14.8597 43.1031C14.9668 43.6281 15.3737 44 15.8878 44H24.1122C24.6263 44 25.0546 43.6281 25.1189 43.1031L25.8899 37.5469C27.1536 37.0219 28.3101 36.3219 29.3596 35.4906L34.4785 37.5906C34.9497 37.7656 35.4851 37.5906 35.7421 37.1094L39.8544 29.8469C40.1114 29.3656 40.0043 28.8187 39.5973 28.5125L35.2924 25.0562Z",
    fill: "#324485"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6462 23.9792C27.689 23.6667 27.7104 23.3438 27.7104 23C27.7104 22.6667 27.689 22.3333 27.6355 22.0208L29.8094 20.375C30.0021 20.2292 30.0557 19.9479 29.9379 19.7396L27.8818 16.2812C27.7533 16.0521 27.4855 15.9792 27.2499 16.0521L24.6905 17.0521C24.1551 16.6562 23.5875 16.3229 22.9557 16.0729L22.5701 13.4271C22.5273 13.1771 22.3131 13 22.0561 13H17.9439C17.6869 13 17.4834 13.1771 17.4406 13.4271L17.055 16.0729C16.4232 16.3229 15.8449 16.6667 15.3202 17.0521L12.7608 16.0521C12.5252 15.9687 12.2574 16.0521 12.1289 16.2812L10.0835 19.7396C9.95502 19.9583 9.99786 20.2292 10.212 20.375L12.3859 22.0208C12.3324 22.3333 12.2896 22.6771 12.2896 23C12.2896 23.3229 12.311 23.6667 12.3645 23.9792L10.1906 25.625C9.99786 25.7708 9.94431 26.0521 10.0621 26.2604L12.1182 29.7188C12.2467 29.9479 12.5145 30.0208 12.7501 29.9479L15.3095 28.9479C15.8449 29.3438 16.4125 29.6771 17.0443 29.9271L17.4299 32.5729C17.4834 32.8229 17.6869 33 17.9439 33H22.0561C22.3131 33 22.5273 32.8229 22.5594 32.5729L22.945 29.9271C23.5768 29.6771 24.1551 29.3438 24.6798 28.9479L27.2392 29.9479C27.4748 30.0312 27.7426 29.9479 27.8711 29.7188L29.9272 26.2604C30.0557 26.0312 30.0021 25.7708 29.7987 25.625L27.6462 23.9792Z",
    fill: "#1F2351"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.3508 35.4479C54.4536 34.6667 54.505 33.8594 54.505 33C54.505 32.1667 54.4536 31.3333 54.3251 30.5521L59.5425 26.4375C60.0051 26.0729 60.1337 25.3698 59.8509 24.849L54.9163 16.2031C54.6078 15.6302 53.9653 15.4479 53.3999 15.6302L47.2572 18.1302C45.9722 17.1406 44.61 16.3073 43.0936 15.6823L42.1683 9.06771C42.0655 8.44271 41.5515 8 40.9347 8H31.0653C30.4485 8 29.9602 8.44271 29.8574 9.06771L28.9321 15.6823C27.4157 16.3073 26.0278 17.1667 24.7685 18.1302L18.6258 15.6302C18.0604 15.4219 17.4179 15.6302 17.1094 16.2031L12.2005 24.849C11.8921 25.3958 11.9949 26.0729 12.5089 26.4375L17.7263 30.5521C17.5978 31.3333 17.495 32.1927 17.495 33C17.495 33.8073 17.5464 34.6667 17.6749 35.4479L12.4575 39.5625C11.9949 39.9271 11.8664 40.6302 12.1491 41.151L17.0837 49.7969C17.3922 50.3698 18.0347 50.5521 18.6001 50.3698L24.7428 47.8698C26.0278 48.8594 27.39 49.6927 28.9064 50.3177L29.8317 56.9323C29.9602 57.5573 30.4485 58 31.0653 58H40.9347C41.5515 58 42.0655 57.5573 42.1426 56.9323L43.0679 50.3177C44.5843 49.6927 45.9722 48.8594 47.2315 47.8698L53.3742 50.3698C53.9396 50.5781 54.5821 50.3698 54.8906 49.7969L59.8252 41.151C60.1337 40.5781 60.0051 39.9271 59.5168 39.5625L54.3508 35.4479Z",
    fill: "#97CEE5",
    fillOpacity: 0.98
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0372 40C32.1469 40 29 36.9027 29 33.0124C29 29.1221 32.1469 26 36.0372 26C39.9274 26 43 29.1221 43 33.0124C43 36.9027 39.9274 40 36.0372 40Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0372 39.8C32.2555 39.8 29.2 36.7904 29.2 33.0124C29.2 29.2335 32.2564 26.2 36.0372 26.2C39.8151 26.2 42.8 29.2307 42.8 33.0124C42.8 36.7931 39.8161 39.8 36.0372 39.8Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -24,
    y: -22,
    width: 88,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: -2,
    y: 1,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 23,
    y: 20,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.266667 0 0 0 0 0.521569 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 31.2286,
    y1: 27.631,
    x2: 40.1591,
    y2: 38.6917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterBrand);
export default __webpack_public_path__ + "static/media/register-brand.b14c7f8f146610e114e874d2f9d41ffb.svg";
export { ForwardRef as ReactComponent };